import React , { useEffect }from "react";
import "aos/dist/aos.css"; 
import '../assets/styles/home.css';
import Home1 from "../assets/images/home1.svg";
import '../../src/components/header';

const HomeSection = () => {
  useEffect(() => {
    // Automatically add cursor-hidden class after typing animation completes
    const mainHeading = document.querySelector(".main-heading");
    setTimeout(() => {
      mainHeading.classList.add("cursor-hidden");
    }, 5000); // Wait for 4s (the typing animation duration)
  }, []);

  return (
    <>
      {/* Hero Section */}
      <section className="home-section" id="home">
        <div className="hero-content">
          <h1 className="main-heading">
          <span className="highlight">Innovate.</span> <span className="highlight">Build.</span> <span className="highlight">Transform</span>
          </h1>
          <h1 className="with-heading">with</h1>
          <h2> Syncrones.</h2>
          <p>Welcome to Syncrones, your gateway to AI-powered innovation and digital<br class="mobile-break" /> excellence.</p>
          <button className="get-started-btn">Get started</button>
        </div>
        <div className="hero-graphic-blur">
 
      <div className="blur-circle left"></div>
    
      <div className="blur-circle middle"></div>
  
      <div className="blur-circle right"></div>
     </div>
        <div className="hero-graphic">
          <img src={Home1} alt="AI Robots" />
        </div>
      </section>
    </>
  );
};

export default HomeSection;
